import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import { Outlet } from "react-router-dom";
import "./layout.scss";

const MainLayout = () => {
  return (
    <main className="d-flex overflow-hidden">
      <Sidebar />
      <main className="main-content">
        {/* <Header /> */}
        <div className="main-content-wrapper">
          <Outlet />
        </div>
      </main>
    </main>
  );
};

export default MainLayout;
